'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventHandler = require('../utils/EventHandler');

var _EventHandler2 = _interopRequireDefault(_EventHandler);

var _Slider = require('../utils/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

var _drawer = require('drawer');

var _drawer2 = _interopRequireDefault(_drawer);

var _DynamicSlideshow = require('./DynamicSlideshow2');

var _DynamicSlideshow2 = _interopRequireDefault(_DynamicSlideshow);

var _DynamicCollection = require('./DynamicCollection');

var _DynamicCollection2 = _interopRequireDefault(_DynamicCollection);

var _DynamicQuoteSlider = require('./DynamicQuoteSlider');

var _DynamicQuoteSlider2 = _interopRequireDefault(_DynamicQuoteSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageFeatures = function () {
  function PageFeatures(section) {
    var _this = this;

    (0, _classCallCheck3.default)(this, PageFeatures);

    this.el = section.el;
    this.ev = new _EventHandler2.default();
    this.headerHeight = document.querySelector('.main-header-wrap').clientHeight;

    this.sections = [];
    this.sectionEls = this.el.querySelectorAll('[data-section-type]');
    this.sectionEls.forEach(function (sectionEl) {
      switch (sectionEl.dataset.sectionType) {
        case 'dynamic-slideshow':
          sectionEl = sectionEl.parentNode;
          _this.sections.push(new _DynamicSlideshow2.default({ el: sectionEl }));
          break;
        case 'dynamic-collection':
          _this.sections.push(new _DynamicCollection2.default({ el: sectionEl }));
          break;
        case 'dynamic-quote-slider':
          _this.sections.push(new _DynamicQuoteSlider2.default({ el: sectionEl }));
          break;
      }
    });

    if (window.location.hash) {
      var preselected = this.el.querySelector(window.location.hash);
      if (preselected && preselected.classList.contains('help-answer')) {
        var preselectedLink = this.el.querySelector('a[href="' + window.location.hash + '"]');
        preselectedLink.classList.add('expanded');
        window.scroll({ top: preselectedLink.offsetTop - this.headerHeight, left: 0, behavior: 'smooth' });
      }
    }

    document.querySelectorAll('.help').forEach(function (help) {
      _this.ev.register(help, 'click', function (e) {
        if (e.target.matches('.help-question.expanded')) {
          e.preventDefault();
          e.target.classList.toggle('expanded');
        } else if (e.target.matches('.help-question')) {
          e.preventDefault();
          e.target.parentElement.querySelectorAll('.expanded').forEach(function (expanded) {
            expanded.classList.remove('expanded');
          });
          e.target.classList.toggle('expanded');
          var trend = _this.ev.register(e.target.nextElementSibling, 'transitionend', function (f) {
            if (f.propertyName !== 'max-height') return;
            var bounding = e.target.getBoundingClientRect();
            if (!(bounding.top >= 0 && bounding.left >= 0 && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight))) {
              window.scrollTo({ top: e.target.offsetTop - _this.headerHeight, left: 0, behavior: 'smooth' });
            }
            _this.ev.unregister(trend);
          });
        } else if (e.target.matches('.help-to-top a')) {
          e.preventDefault();
          window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        }
      });
    });

    this.el.querySelectorAll('.page-feature-navigation .page-nav-item[href^="#"]').forEach(function (el) {
      _this.ev.register(el, 'click', function (e) {
        e.preventDefault();
        var hash = e.currentTarget.hash;
        hash = hash.replace('#', '');
        var hashEl = document.getElementById(hash);
        window.scroll({ top: hashEl.offsetTop - _this.headerHeight, left: 0, behavior: 'smooth' });
      });
    });

    if (this.el.querySelector('.yotpo.product-reviews-slider')) {
      new _Slider2.default(this.el.querySelector('.yotpo.product-reviews-slider'), {
        pauseAutoPlayOnHover: false,
        pageDots: false,
        groupCells: true
      });
    }

    if (this.el.querySelector('.rimg-video')) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            io.unobserve(entry.target);
            entry.target.src = entry.target.dataset.src;
            window.dataLayer.push({ 'event': 'Played Video - Below the Fold', 'videoId': entry.target.dataset.videoId });
          }
        });
      }, {
        rootMargin: '20% 0px'
      });

      this.el.querySelectorAll('.rimg-video').forEach(function (video) {
        io.observe(video);
      });
    }

    var careTrigger = this.el.querySelector('[data-special-care-trigger]');

    if (careTrigger) {
      this.specialCareDrawer = new _drawer2.default(document.getElementById('drawer-legacy-care-special-instructions'));

      this.ev.register(careTrigger, 'click', function (e) {
        e.preventDefault();
        _this.specialCareDrawer.open();
      });
    }

    var logoCarousel = this.el.querySelector('.as-seen-on-logo-carousel');

    if (logoCarousel) {
      new _Slider2.default(logoCarousel, {
        wrapAround: true,
        autoPlay: this.autoPlay,
        pauseAutoPlayOnHover: false,
        pageDots: false
      });
    }

    if (document.querySelector('.contact-form')) {
      document.querySelector('.contact-form').addEventListener('submit', function (e) {
        var subject = e.target.querySelector('#issueSelect').value;
        var issue = e.target.querySelector('#subIssueSelect').value;
        window.heap && window.heap.track('ContactFormSubmit', { subject: subject, issue: issue });
      });
    }
  }

  (0, _createClass3.default)(PageFeatures, [{
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      this.ev.unregisterAll();
      this.sections.forEach(function (section) {
        return section.onSectionUnload();
      });
    }
  }]);
  return PageFeatures;
}();

exports.default = PageFeatures;